import { ChatMentionSuggestion, PromptChatAdapter } from '../../components/Chat/PromptChatAdapter';
import { designerChatAgentIds, designerChatScopes, useDesignerChatAdapter } from '../../components/Chat/useDesignerChatAdapter';
import { SchemaValueModel } from '../FlowDesigner/Models/SchemaValueModel';

export type TemplateChatContext = {
	changeSetId?: string | null;
	name?: string;
	category?: string;
	inputSchemaValue?: SchemaValueModel;
};

function getInputPropertyNames(inputSchemaValue: SchemaValueModel | undefined): string[] {
	const properties = inputSchemaValue?.Value?.properties;
	if (!properties || typeof properties !== 'object') {
		return [];
	}

	return Object.keys(properties);
}

export function useTemplateChatAdapter(templateId: string | undefined, context: TemplateChatContext, requireTemplateId: boolean = true): PromptChatAdapter {
	return useDesignerChatAdapter({
		scopeName: designerChatScopes.template,
		agentId: designerChatAgentIds.template,
		isAvailable: !requireTemplateId || !!templateId,
		missingTargetMessage: 'Save the template before starting a chat.',
		messageAttributes: () => ({
			CurrentTemplateId: templateId,
			ChangeSetId: context.changeSetId ?? undefined,
		}),
		searchMentions: async (query: string): Promise<ChatMentionSuggestion[]> => {
					const q = query.toLowerCase();
					const suggestions: ChatMentionSuggestion[] = [];

					if (context.name && context.name.toLowerCase().includes(q)) {
						suggestions.push({ name: context.name, type: 'Template' });
					}

					if (context.category && context.category.toLowerCase().includes(q)) {
						suggestions.push({ name: context.category, type: 'Category' });
					}

					for (const propertyName of getInputPropertyNames(context.inputSchemaValue)) {
						if (propertyName.toLowerCase().includes(q)) {
							suggestions.push({ name: propertyName, type: 'Input' });
						}
					}

					return suggestions;
		},
	});
}
